import React from "react";
import Ample from "../components/ample/ample";
import {formatCurrency} from "../utils";
import ExpirySelector from "../components/expiryselector";
import TickerDropDown from "../components/tickerdropdown";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { OutboundLink } from "gatsby-plugin-google-gtag";
import Grid from "@mui/material/Grid";
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import {logEvent} from "../analytics";
import ExplainerCard from "../components/general/explainercard";
import ChatPromoBanner from "../components/chatpromobanner";

const MAX_PAIN_PAGE_HEADING = "Options Max Pain Calculator";
const MAX_PAIN_SEO_TITLE = "Options Max Pain Calculator for Stocks & ETFs | optiontrader.tools";
const MAX_PAIN_SEO_DESCRIPTION = "Calculate options max pain by expiration for stocks and ETFs, including leveraged and inverse ETFs. View call and put open interest and cumulative option liability by strike.";

const guideHeadingStyle = {
  margin: "0 0 8px 0",
  fontSize: "1.15rem",
  fontWeight: 600,
  color: "#2c3e50"
};
const guideBodyStyle = {
  margin: 0,
  color: "#555",
  fontSize: "0.95rem",
  lineHeight: 1.6
};
const guideListStyle = {
  margin: "0 0 0 18px",
  padding: 0,
  color: "#555",
  fontSize: "0.95rem",
  lineHeight: 1.6
};
const guideSectionStyle = {
  marginBottom: "20px"
};

export default class MaxPainPage extends React.Component {
  state = {
    ticker: "CHWY",
    expiry: "",
    resultsTicker: "",
    resultsExpiry: "",
    resultsVisible : false,
    optiondata: [],
    backdropActive:false
  }

  
  // #region form events
  formValid() {
    return ((this.state.ticker.trim() !== "") && (this.state.expiry.trim() !== ""))
  }
  tickerChanged = newTicker => {
    this.setState({ticker:newTicker});
  }
  expiryChanged = newExpiry => {
    this.setState({expiry:newExpiry});
  }

  resetForm = event => {
    this.setState({resultsVisible:false});
    logEvent("resetForm");
  }
  formSubmitted = event => {
    this.requestOptionData()
  }
  //#endregion
  
  // #region Fetch Data
  requestOptionData() {
    const requestedTicker = this.state.ticker;
    const requestedExpiry = this.state.expiry;
    const url = `${process.env.GATSBY_TICKER_API_ENDPOINT}/${requestedTicker}/max-pain?expiry=${requestedExpiry}`
    const params = {url:url, ticker:requestedTicker, expiry:requestedExpiry};
    
    //console.log(url)
    this.setState({ resultsVisible:false, backdropActive:true}
                  ,()=>fetch(url)
                    .then(res => res.json())
                    .then((data) => this.setState({
                      optiondata: data,
                      resultsTicker: requestedTicker,
                      resultsExpiry: requestedExpiry
                    }))
                    .then(()=>{this.setState({resultsVisible:true,backdropActive:false})})
                    .then(()=>logEvent("requestMaxPain_Success", params))
                    //.then(()=>this.sortData(this.SortMode.CumulativeLiability))
                    .catch((e)=>logEvent("requestMaxPain_Failed", params))
                  );
  }
  //#endregion

  // #region sorting
  SortMode = {
    Strike:0, PutInterest:1, CallInterest:2, CumulativeLiability:3
  }
  
  sortData(mode) {
      let data = this.state.optiondata
      switch (mode) {
        case this.SortMode.Strike:
          data.sort( (a,b) => b.strike - a.strike )
          break
        case this.SortMode.PutInterest:
          data.sort( (a,b) => b.putInterest - (a.putInterest)  )
          break
        case this.SortMode.CallInterest:
          data.sort( (a,b) =>  (b.callInterest) - (a.callInterest))
          break
        default:
          data.sort( (a,b) => a.CumulativeLiability - b.CumulativeLiability )
      }
      this.setState({optiondata:data})
  }
  requestSort = (mode) => {
      this.sortData(mode);
      logEvent("requestSort", {mode:mode});
  }
  //#endregion

  // #region UI rendering methods
  optionTable()  {
    let data=this.state.optiondata;
    let maxPainOption = data.find(opt => opt.IsMaxPain);
    let calloutStyle = {
      marginBottom: "12px",
      color: "#67757c"
    };
    let maxPainStyle = {
      backgroundColor:'#545b62',
      color: '#ffffff'
    }
    let optiondatatable= (
      <Card>
      <CardContent>
        {maxPainOption && (
          <p style={calloutStyle}>
            Max pain strike for <strong>{this.state.resultsTicker}</strong> on <strong>{this.state.resultsExpiry}</strong> is <strong>{maxPainOption.strike}</strong>
          </p>
        )}
        <table width="100%" className="table">
        <thead>
          <tr>
            <th className="border-top-0" onClick={() => this.requestSort(this.SortMode.Strike)}>Strike&nbsp;<i className="fas fa-sort"></i></th>
            <th className="border-top-0" onClick={() => this.requestSort(this.SortMode.CallInterest)}>Call Interest&nbsp;<i className="fas fa-sort"></i></th>
            <th className="border-top-0" onClick={() => this.requestSort(this.SortMode.PutInterest)}>Put Interest&nbsp;<i className="fas fa-sort"></i></th>
            <th className="border-top-0" onClick={() => this.requestSort(this.SortMode.CumulativeLiability)}>Cumulative Liability&nbsp;<i className="fas fa-sort"></i></th>
            </tr>
        </thead>
        <tbody>
        {data.map(opt=> {
            return (<tr key={opt.strike} style={ opt.IsMaxPain ? maxPainStyle : {}  }>
            <td>{opt.strike}</td>
            <td>{opt.callInterest}</td>
            <td>{opt.putInterest}</td>
            <td>{formatCurrency(opt.CumulativeLiability,0)}</td>
            </tr>)
          })}
        </tbody>
        </table>
      </CardContent>
      </Card>

    )
    return optiondatatable;
  }
  
  searchCard = () => {
    return (
    <Card>
      <CardContent>
        <table>
        <tbody>
          <tr>
            <td><TickerDropDown OptionsOnly={true} defaultTicker={this.state.ticker}  onSelectedTickerChanged={this.tickerChanged} helperText="Select stock, ETF, or index"/></td>
            <td><ExpirySelector ticker={this.state.ticker} id="optionExpirySelector" onSelectedExpiryChange={this.expiryChanged} aria-label="Select expiry date"/></td>
          </tr>
        </tbody>
        </table>
        <br/>
        
        <button disabled={!this.formValid()} id="go" onClick={this.formSubmitted}  type="submit"  className="btn btn-rounded btn-default btn-outline">
          <i className="fas fa-play-circle  m-r-5"></i>Show</button>
        <button disabled={!this.state.resultsVisible} id="clear" onClick={this.resetForm} className="btn btn-rounded btn-default btn-outline" >
            <i className="fas fa-eraser  m-r-5"></i>Clear</button>
      </CardContent>
    </Card>);
  }


  explainerCard = () => {
    return (
      <ExplainerCard 
        description={
          <p style={{ margin: 0 }}>
            Calculate the <b>max pain</b> strike for a stock or ETF expiration from listed call and put open interest. Based on <OutboundLink href="https://www.investopedia.com/terms/m/maxpain.asp">maximum pain theory</OutboundLink>: price often gravitates toward the strike with the least option-writer liability.
          </p>
        }
        instructions={
          <>
            <h3 style={{ margin: '0 0 12px 0', fontSize: '1rem', fontWeight: 600 }}>How to Use It</h3>
            <p style={{ margin: '0 0 12px 0' }}>
              Select a ticker and expiration, then press <i className="fas fa-play-circle  m-r-5"></i> Show. The table lists call open interest, put open interest, and cumulative option liability at each strike. The max pain row is highlighted.
            </p>
            <h3 style={{ margin: '0 0 12px 0', fontSize: '1rem', fontWeight: 600 }}>Why Use It</h3>
            <p style={{ margin: 0 }}>
              Use it to see where option liability is concentrated into an expiration, including on leveraged and inverse ETFs. It is a snapshot of positioning, not a price target.
            </p>
          </>
        }
        howItWorks={
          <>
            <h3 style={{ margin: '0 0 12px 0', fontSize: '1rem', fontWeight: 600 }}>How It Works</h3>
            <p style={{ margin: 0 }}>
              For each listed strike, the calculator sums the dollar value of calls and puts that would finish in the money if the underlying expired at that strike. That total is cumulative liability. Max pain is the strike where this total is smallest, using <OutboundLink href="https://www.investopedia.com/terms/o/openinterest.asp">open interest</OutboundLink> from the Yahoo Finance option chain (typically prior-session, not intraday).
            </p>
          </>
        }
      />
    );
  }

  guideCard = () => {
    return (
      <Card>
        <CardContent className="font-light" style={{ padding: "20px 24px" }}>
          <section style={guideSectionStyle}>
            <h2 style={guideHeadingStyle}>What is options max pain?</h2>
            <p style={guideBodyStyle}>
              Options max pain is the strike where listed calls and puts would pay out the least if the underlying expired at that price. The usual story is that dealers and other option sellers, in aggregate, are least exposed there, so price can pin toward that strike into expiration. Treat it as a map of open-interest liability, not a prediction that the stock or ETF must close there.
            </p>
          </section>

          <section style={guideSectionStyle}>
            <h2 style={guideHeadingStyle}>How this calculator computes max pain</h2>
            <p style={{ ...guideBodyStyle, marginBottom: "8px" }}>
              Pick a ticker and expiration. We load that expiry’s Yahoo Finance chain and, at every listed strike, take call open interest and put open interest. Missing open interest is treated as zero.
            </p>
            <p style={{ ...guideBodyStyle, marginBottom: "8px" }}>
              Then, for every candidate expiry price <i>T</i> (each listed strike), we add writer liability if the underlying settled at <i>T</i>:
            </p>
            <ul style={{ ...guideListStyle, marginBottom: "8px" }}>
              <li>Calls struck below <i>T</i> are in the money: call open interest × (<i>T</i> − strike) × 100</li>
              <li>Puts struck above <i>T</i> are in the money: put open interest × (strike − <i>T</i>) × 100</li>
              <li>At <i>T</i>, intrinsic value is zero</li>
            </ul>
            <p style={guideBodyStyle}>
              That sum is cumulative liability. Max pain is the strike with the lowest total. If two or more strikes tie, each is highlighted.
            </p>
          </section>

          <section style={guideSectionStyle}>
            <h2 style={guideHeadingStyle}>How to interpret the results</h2>
            <p style={guideBodyStyle}>
              The highlighted row is max pain for the expiration you selected. Call interest and put interest are contract open interest at that strike; cumulative liability is the dollar payout to option holders if the underlying expired exactly there. Sorting by cumulative liability shows whether pain is concentrated at one strike or spread across a range. Large call open interest below a strike raises liability if price finishes higher; large put open interest above a strike raises liability if price finishes lower.
            </p>
          </section>

          <section style={guideSectionStyle}>
            <h2 style={guideHeadingStyle}>Stocks and ETFs supported</h2>
            <p style={guideBodyStyle}>
              The ticker list is options-listed U.S. stocks and ETFs from the NASDAQ, NYSE, and ETF screens we refresh, including leveraged and inverse ETFs such as SPXL and SPXU (and other 2x/3x funds such as TQQQ and SQQQ). A few index underlyings with listed options, such as SPX, NDX, and VIX, are included as well. Newly listed products show up after the next universe refresh.
            </p>
          </section>

          <section style={{ marginBottom: 0 }}>
            <h2 style={guideHeadingStyle}>Limitations of max pain</h2>
            <ul style={guideListStyle}>
              <li>Open interest is not intraday. Yahoo’s chain typically reflects the prior session, and traders can open or close contracts before we (or anyone) see the update.</li>
              <li>Open interest changes through the cycle, so the max pain strike can move, especially near expiration.</li>
              <li>The calculation uses listed strikes and open interest only. It does not model dealer hedging, gamma, or trades outside this chain.</li>
              <li>It is not predictive certainty. Stocks and ETFs regularly expire away from max pain.</li>
              <li>For leveraged and inverse ETFs, the options are on the ETF itself, not a one-to-one map of the underlying index.</li>
            </ul>
          </section>
        </CardContent>
      </Card>
    );
  }

  render() {
    return (
    <Ample currPageTitle={MAX_PAIN_SEO_TITLE}  seoDescription={MAX_PAIN_SEO_DESCRIPTION}  location={this.props.location.href}>
      <h1 style={{ fontSize: "1.75rem", fontWeight: 700, margin: "0 0 8px 0", color: "#2c3e50" }}>
        {MAX_PAIN_PAGE_HEADING}
      </h1>
        
      <Backdrop style={{zIndex:  1,color: '#fff',}} open={this.state.backdropActive}  >
        <CircularProgress color="inherit" />
      </Backdrop>

      <Grid container spacing={2}>
        <Grid item lg={12}>
          <ChatPromoBanner source="maxpain_banner" />
        </Grid>
        
        <Grid item  lg={12}  >
          {this.explainerCard()}
        </Grid>

        <Grid item lg={12} sx={{width:1, justifyContent:'right'}}>
            {this.searchCard()}
        </Grid>

        {this.state.resultsVisible && (
          <Grid item lg={12}>
            {this.optionTable()}
          </Grid>
        )}

        <Grid item lg={12}>
          {this.guideCard()}
        </Grid>
      </Grid>

      </Ample>
    )
  }
  //#endregion
}
